import { render, staticRenderFns } from "./candidate-list-skeleton.vue?vue&type=template&id=3a07ea64&scoped=true&"
import script from "./candidate-list-skeleton.vue?vue&type=script&lang=js&"
export * from "./candidate-list-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./candidate-list-skeleton.vue?vue&type=style&index=0&id=3a07ea64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a07ea64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSkeletonLoader,VTextField})
